import { Select } from "antd";
import React from "react";
import { PREP_NEW_LETTER_OPTIONS } from "../../../constants/constant";

const PrepNewsLetter = (props) => {
  return (
    <>
      <Select
        {...props}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        allowClear
      >
        {PREP_NEW_LETTER_OPTIONS?.map((data) => {
          return (
            <Select.Option key={data?.id} value={data.id}>
              {data?.name}
            </Select.Option>
          );
        })}
      </Select>
    </>
  );
};
export default PrepNewsLetter;
